import { Component, ChangeDetectionStrategy, Input, inject } from '@angular/core';
import { from, Observable } from 'rxjs';
import { TuiSizeL, TuiSizeM, TuiSizeS } from '@taiga-ui/core';
import { CommitteeView } from '@src/api';
import { ViewMode } from '@src/models';
import { CommitteeService } from '@src/core/services';

@Component({
  selector: 'app-field-committee',
  templateUrl: './field-committee.component.html',
  styleUrls: ['./field-committee.component.scss', '../styles/field-content.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FieldCommitteeComponent {
  private readonly committeeService = inject(CommitteeService);

  @Input() mode?: ViewMode = 'view';
  @Input() name?: string;
  @Input() set committeeId(value: string | undefined | null) {
    this.committee$ = undefined;
    if (value) {
      this.committee$ = from(this.committeeService.getCommitteeAsync(value));
    }
  }
  @Input() size: TuiSizeS | TuiSizeM | TuiSizeL = 'l';

  committee$?: Observable<CommitteeView>;
}
